"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEventType = void 0;
var GameEventType;
(function (GameEventType) {
    GameEventType["CLAIM_TEST"] = "CLAIM_TEST";
})(GameEventType || (exports.GameEventType = GameEventType = {}));
//# sourceMappingURL=game.js.map